module.exports = __webpack_public_path__ + "img/1.a89c95fb.jpg";